import { Breadcrumbs, Typography } from "@mui/material";

import { ChevronRight } from "lucide-react";

export function ZoneBreadcrumbs({ path }: { path: string[] }) {
  return (
    <Breadcrumbs
      separator={
        <Typography
          color={"textSecondary"}
          variant={"bodySmallMedium"}
          sx={{ height: 20 }}
        >
          <ChevronRight size={20} />
        </Typography>
      }
    >
      {path.map((item) => (
        <Typography
          key={item}
          color={"textSecondary"}
          variant={"bodySmallMedium"}
        >
          {item}
        </Typography>
      ))}
    </Breadcrumbs>
  );
}
